import actionTypes from '../actionTypes'

export default {
    setFocusedElement: (focusedElement) => ({
        type: actionTypes.SET_UI_FOCUS,
        focusedElement
    })
}
